// Totals for the senior appointment checkout summary.
//
// Kept as a pure function (no React) so it can be unit-tested and so the
// itemized "Discount" line always reconciles: subtotal - discount + tax = total.
//
// Real flow: read from the cart. The cart exposes `subtotalWithoutCoupon` (the
// pre-coupon subtotal) and `couponValue` (the discount amount), so the Subtotal
// line shows the full price and the Discount line shows what the coupon took off.
// `subtotal` on the cart is already post-coupon, so it is NOT used for the
// Subtotal line (that would hide the discount).
//
// Demo/localhost fallback: no cart, so sum the passed-in item prices (no coupon).
export const computeSummaryTotals = (cart, items = []) => {
  if (cart) {
    const discount = Number(cart.couponValue) || 0;
    const subtotal = cart.subtotalWithoutCoupon != null
      ? Number(cart.subtotalWithoutCoupon)
      : (Number(cart.subtotal) || 0);
    const tax = Number(cart.apiTax) || 0;
    const total = cart.apiTotal != null
      ? Number(cart.apiTotal)
      : subtotal - discount + tax;

    return {
      subtotal, discount, tax, total,
    };
  }

  const subtotal = items.reduce((sum, item) => sum + (item.price || 0), 0);
  return {
    subtotal, discount: 0, tax: 0, total: subtotal,
  };
};

export default computeSummaryTotals;
